import { render } from "./WholeRetreatModel.vue?vue&type=template&id=6568c595"
import script from "./WholeRetreatModel.vue?vue&type=script&lang=js"
export * from "./WholeRetreatModel.vue?vue&type=script&lang=js"

import "./WholeRetreatModel.vue?vue&type=style&index=0&id=6568c595&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__